import { render, staticRenderFns } from "./VAddressField.vue?vue&type=template&id=0382e08c&scoped=true"
import script from "./VAddressField.vue?vue&type=script&lang=js"
export * from "./VAddressField.vue?vue&type=script&lang=js"
import style0 from "./VAddressField.vue?vue&type=style&index=0&id=0382e08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0382e08c",
  null
  
)

export default component.exports